/**
 * Created by hcy on 2017/11/21.
 */

// goodTime     格式化时间
// isMobile     验证手机号
// isnull       是否为空
// isCard       验证银行卡号
// codeTimeout  发送验证码倒计时
// isLetter     验证纯字母
// isNumber     验证纯数字
// getUrlParam  获取浏览器地址栏参数
// Encrypt      aes加密
// Decrypt      aes解密
// getCitycodeName  根据citycode值获取城市名字
// isEmail       邮箱验证
// isNumerAZ     数字字母
// isID          身份证号
// ispostalCode  邮政编码
// getDate       截取年月日

export default {
  goodTime (str) {
    let now = new Date().getTime()
    let oldTime = new Date(str).getTime()
    let difference = now - oldTime
    let result = ''
    let minute = 1000 * 60
    let hour = minute * 60
    let day = hour * 24
    let month = day * 30
    let year = month * 12
    let _year = difference / year
    let _month = difference / month
    let _week = difference / (7 * day)
    let _day = difference / day
    let _hour = difference / hour
    let _min = difference / minute

    if (_year >= 1) {
      result = '发表于 ' + ~~(_year) + ' 年前'
    } else if (_month >= 1) {
      result = '发表于 ' + ~~(_month) + ' 个月前'
    } else if (_week >= 1) {
      result = '发表于 ' + ~~(_week) + ' 周前'
    } else if (_day >= 1) {
      result = '发表于 ' + ~~(_day) + ' 天前'
    } else if (_hour >= 1) {
      result = '发表于 ' + ~~(_hour) + ' 个小时前'
    } else if (_min >= 1) {
      result = '发表于 ' + ~~(_min) + ' 分钟前'
    } else {
      result = '刚刚'
    }
    return result
  },
  formatDate (date) {
    const y = date.getFullYear()
    let m = date.getMonth() + 1
    m = m < 10 ? '0' + m : m
    let d = date.getDate()
    d = d < 10 ? ('0' + d) : d
    return y + m + d
  },
  formatDate2 (date) {
    const y = date.getFullYear()
    let m = date.getMonth() + 1
    m = m < 10 ? '0' + m : m
    let d = date.getDate()
    d = d < 10 ? ('0' + d) : d
    return y + '年' + m + '月' + d + '日'
  },
  formatDate3 (date) {
    const y = date.getFullYear()
    let m = date.getMonth() + 1
    m = m < 10 ? '0' + m : m
    let d = date.getDate()
    d = d < 10 ? ('0' + d) : d
    return y + '-' + m + '-' + d
  },
  getFormatTime (str) {
    let time = str.substring(0, 4) + '年' + str.substring(5, 7) + '月' + str.substring(8, 10) + '日' + ' ' + str.substring(11, 16)
    return time
  },
  getUrlParam (argName) {
    var args = location.href.split('?')
    var retval = ''
    var str = decodeURI(args[1])
    if (str) {
      var _args = str.split('#')[0]
      args = _args.split('&')
      for (var i = 0; i < args.length; i++) {
        _args = args[i]
        var arg = _args.split('=')
        if (arg.length <= 1) {
          continue
        }
        if (arg[0] === argName) {
          retval = arg[1]
        }
      }
    }
    return retval
  },
  getCitycodeName (code, proideList) {
    if (!this.isnull(code)) {
      let bb = code.substr(0, 4) + '00'
      let cc = code.substr(0, 2) + '0000'
      for (let i = 0; i < proideList.length; i++) {
        if (proideList[i].code === cc) {
          for (let j = 0; j < proideList[i].childrenList.length; j++) {
            if (proideList[i].childrenList[j].code === bb) {
              for (let g = 0; g < proideList[i].childrenList[j].childrenList.length; g++) {
                if (proideList[i].childrenList[j].childrenList[g].code === code) {
                  return proideList[i].name + ' - ' + proideList[i].childrenList[j].name + ' - ' + proideList[i].childrenList[j].childrenList[g].name
                }
              }
            }
          }
        }
      }
    } else {
      return ''
    }
  },
  getWechatConfig () {
    var url = window.location.href
    window.$.ajax({
      type: 'POST',
      url: window.rootUrl + '/baner/00_1003.do',
      dataType: 'json',
      async: false,
      data: {
        'url': url
      },
      timeout: 35 * 1000,
      cache: false,
      complete: function (XMLHttpRequest, status) {
      },
      beforeSend: function (XMLHttpRequest) {
        XMLHttpRequest.setRequestHeader('Cache-Control', 'no-cache')
      },
      error: function (XMLHttpRequest, status, thrownError) {
        let div = document.createElement('div')
        div.setAttribute('id', 'error')
        div.innerHTML = '<div class="ui-poptips-n ui-poptips-success"><div class="ui-poptips-cnt margin-lr-5">获取微信签名失败,请重试!</div></div>'
        document.getElementById('app').appendChild(div)
        setTimeout(function () {
          let errorId = document.getElementById('error')
          document.getElementById('app').removeChild(errorId)
        }, 2000)
      },
      success: function (resp) {
        var appid = resp.appid
        var timestamp = resp.timestamp
        var nonceStr = resp.nonceStr
        var signature = resp.signature
        window.wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: appid, // 必填，公众号的唯一标识
          timestamp: timestamp, // 必填，生成签名的时间戳
          nonceStr: nonceStr, // 必填，生成签名的随机串
          signature: signature, // 必填，签名，见附录1
          jsApiList: [
            'checkJsApi',
            'scanQRCode',
            'closeWindow',
            'translateVoice',
            'chooseImage',
            'getLocalImgData',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'onMenuShareTimeline',
            'onMenuShareAppMessage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
      }
    })
  },
  getWechatUserInfo () {
    window.$.ajax({
      type: 'POST',
      url: window.rootUrl + '/baner/00_1004.do',
      dataType: 'json',
      async: false,
      data: {
        'openid': localStorage.openid
      },
      timeout: 35 * 1000,
      cache: false,
      complete: function (XMLHttpRequest, status) {
      },
      beforeSend: function (XMLHttpRequest) {
        XMLHttpRequest.setRequestHeader('Cache-Control', 'no-cache')
      },
      error: function (XMLHttpRequest, status, thrownError) {
        let div = document.createElement('div')
        div.setAttribute('id', 'error')
        div.innerHTML = '<div class="ui-poptips-n ui-poptips-success"><div class="ui-poptips-cnt margin-lr-5">获取用户信息失败,请重试!</div></div>'
        document.getElementById('app').appendChild(div)
        setTimeout(function () {
          let errorId = document.getElementById('error')
          document.getElementById('app').removeChild(errorId)
        }, 2000)
      },
      success: function (resp) {
        localStorage.wechatUserInfo = JSON.stringify(resp)
      }
    })
  },
  getCode (str) {
    let parms = JSON.parse(sessionStorage.banner_code)
    let codeArry = []
    for (let i = 0; i < parms.length; i++) {
      if (parms[i].paramId === str) {
        codeArry.push(parms[i])
      }
    }
    return codeArry
  },
  getBodyBgFFF () {
    let div = document.getElementsByTagName('body')[0]
    let height = window.innerHeight + 'px'
    div.style.height = height
    div.style.backgroundColor = '#FFF'
  },
  getBodyBgF8 () {
    let div = document.getElementsByTagName('body')[0]
    let height = window.innerHeight + 'px'
    div.style.height = height
    div.style.backgroundColor = '#F8F8F8'
  },
  getDate (val) {
    if (!this.isnull(val)) {
      return val.substring(0, 10)
    }
  },
  isMobile (str) {
    let reg = /^1[3|5|7|8]\d{9}$/
    return reg.test(str)
  },
  isphoneNo (str) {
    let reg = /0\d{2}-\d{7,8}/
    return reg.test(str)
  },
  isAllphoneNo (str) {
    let reg = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/
    return reg.test(str)
  },
  isHomeArea (str) {
    let reg = /^\d+(\.\d+)?$/
    return reg.test(str)
  },
  isnull (str) {
    return (str == null || str === 'null' || (typeof str) === 'undefined' || str === '')
  },
  isCard (str) {
    let reg = /^(\d{16}|\d{19})$/
    return reg.test(str)
  },
  isVerCode (str) {
    if (str.length === 6) {
      return true
    } else {
      return false
    }
  },
  isNumber (str) {
    let reg = /^[0-9]*$/
    return reg.test(str)
  },
  isLetter (str) {
    let reg = /^[a-zA-Z]+$/
    return reg.test(str)
  },
  isID (str) {
    let reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$)/
    return reg.test(str)
  },
  ispostalCode (str) {
    let reg = /^[1-9][0-9]{5}$/
    return reg.test(str)
  },
  isObjnull (obj) {
    let i = ''
    for (i in obj) {
      if (obj[i] === 'null' || obj[i] === null) {
        obj[i] = ' '
      }
    }
  },
  isCardNum18 (obj) {
    let reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
    return reg.test(obj)
  },
  isCardNum15 (obj) {
    let reg = /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$/
    return reg.test(obj)
  },
  isEmail (obj) {
    let reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
    return reg.test(obj)
  },
  isNumerAZ (str) {
    let reg = /^[A-Za-z0-9]+$/
    return reg.test(str)
  },
  isAge (str) {
    let reg = /^[0-9]{1,2}$/
    return reg.test(str)
  },
  iswechat () {
    let ua = navigator.userAgent.toLowerCase()
    return ua.match(/micromessenger/i) == 'micromessenger'
  },
  isIOS () {
    let ua = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
    return ua
  },
  isAndroid () {
    let ua = /(Android)/i.test(navigator.userAgent)
    return ua
  },
  getBindCardUrl(){
      // 我要办卡地址
      let bindCardUrl = 'https://creditcard.cmbc.com.cn/wsv2/?enstr=j6zQQpKLvA5X%2f0wcJaZMb2EhOWpltJeY4UTurBOL6qdq7Mt7hTPzeAQ%2bwGqOCHuMqiGLzNbRlpjE%2fjbq4Fpgn%2bwrDbINI1khJCjgmwJ2Ai45wVATUnIOT8NUuNWNGLgKFosJKX%2b6Fi8csmjSnfbswXHFSW7UErt3U1BZZrvIc07E8Y%2f5XDJMfTroVIk%2ff11yJXuGmg5x1kFil2KXG5Rnr89c%2fVNycZuUtKOdz58y5da2YmgDHui0Qmpx%2byoVMXH1JSJ2cMAyiL%2fN1FpbVRMtuj7yVyG5Md2LhHUgANHp5EujN0sCaoQH2lRVA%2f1u%2bF7SIyiE8nfwX%2b95mlbFH0wraw%3d%3d'
      return bindCardUrl
  }
}



// WEBPACK FOOTER //
// ./src/utils?v=1.0